<div class="iframe-container">
  <iframe #iframe [src]="iframeUrl" width="100%" allowfullscreen></iframe>
</div>
